import { render, staticRenderFns } from "./TagMultiselect.vue?vue&type=template&id=d15f53d6&scoped=true"
import script from "./TagMultiselect.vue?vue&type=script&lang=ts"
export * from "./TagMultiselect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15f53d6",
  null
  
)

export default component.exports